module.exports = __webpack_public_path__ + "static/media/avatars_male_12.9c977070.png";